"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var _ = __importStar(require("lodash"));
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var UserStore_1 = require("stores/UserStore");
var LoginForm_1 = __importDefault(require("./LoginForm"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("../Notification");
var logo_white_svg_1 = __importDefault(require("res/img/logo-white.svg"));
var Login = function () {
    var _a = react_1.useState({
        emailAddress: '',
        password: '',
        rememberMe: true
    }), data = _a[0], setData = _a[1];
    var _b = react_1.useState(false), exiting = _b[0], setExiting = _b[1];
    var _c = react_1.useState(false), success = _c[0], setSuccess = _c[1];
    var _d = use_stores_1.useStores(), userStore = _d.userStore, apiStore = _d.apiStore;
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var exitingTimeout = react_1.useRef(null);
    var redirectTimeout = react_1.useRef(null);
    react_1.useEffect(function () {
        document.title = 'Login';
    }, []);
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function (e) {
        e.preventDefault();
        var error = null;
        for (var k in data) {
            if (data.hasOwnProperty(k)) {
                if (data[k].length <= 0) {
                    error = "Please enter your " + _.startCase(k);
                    break;
                }
            }
        }
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        data.rememberMe = true;
        api_1.default.login(data)
            .then(function (response) { return completeLogin(response.data); })
            .catch(api_1.catchHandler);
    };
    var completeLogin = function (responseData) {
        userStore.setData(responseData);
        setSuccess(true);
        clearTimeout(exitingTimeout.current);
        exitingTimeout.current = setTimeout(function () {
            setExiting(true);
            clearTimeout(redirectTimeout.current);
            redirectTimeout.current = setTimeout(function () {
                if (userStore.data.databaseConnection === UserStore_1.CODA)
                    history.replace("/products/?login=true");
                else
                    history.replace("/?login=true");
            }, 1000);
        }, 1000);
    };
    return (react_1.default.createElement("div", { className: 'login', "data-exiting": exiting },
        react_1.default.createElement("div", { className: 'login__logo' },
            react_1.default.createElement("img", { src: logo_white_svg_1.default, alt: 'RWD logo' })),
        react_1.default.createElement(LoginForm_1.default, { data: data, onChange: changeHandler, onSubmit: submitHandler, busy: apiStore.data.busyRoutes.includes(config_1.default.apiRoutes.LOGIN), success: success })));
};
exports.default = Login;
